export default {
  metadata: {
    version: '1.0.0',
    id: 'tooltip-1.0.0',
    name: 'JDSTooltipInternal',
    description:
      'Tooltips are floating elements primarily used for accessibility as its function. It is used to display additional information about a user interface element or feature.',
    usage:
      'The information included should be contextual, helpful, and nonessential while providing that extra ability to communicate and give clarity to a user.'
  },
  hierarchy: {
    'root-container': [
      'start-tooltip',
      {
        'text-container': ['jds-text']
      },
      'end-tooltip'
    ]
  },
  base: {
    'root-container': {
      'flex-direction': '{t_3}',
      'justify-content': '{t_4}',
      'align-items': '{t_5}',
      overflow: '{tooltip_base_root-container-overflow}'
    },
    'text-container': {
      'border-radius': '{t_7}',
      'border-width': '{t_8}',
      'background-color': '{t_9}',
      'padding-left': '{t_12}',
      'padding-right': '{t_13}',
      'padding-top': '{t_14}',
      'padding-bottom': '{t_15}',
      'min-height': '{t_40}',
      'align-items': '{t_41}'
    },
    'start-tooltip': {
      color: '{t_10}',
      position: 'right',
      hidden: false
    },
    'end-tooltip': {
      color: '{t_11}',
      position: 'right',
      hidden: true
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_19}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    position: {
      right_start: {
        'root-container': {
          'align-items': '{t_16}'
        },
        'start-tooltip': {
          position: 'right_start',
          'padding-top': '{t_17}',
          hidden: false
        },
        'end-tooltip': {
          hidden: true
        }
      },
      right_end: {
        'root-container': {
          'align-items': '{t_18}'
        },
        'start-tooltip': {
          position: 'right_end',
          'padding-bottom': '{t_19}',
          hidden: false
        },
        'end-tooltip': {
          hidden: true
        }
      },
      left: {
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'left',
          hidden: false
        }
      },
      left_start: {
        'root-container': {
          'align-items': '{t_20}'
        },
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'left_start',
          'padding-top': '{t_21}',
          hidden: false
        }
      },
      left_end: {
        'root-container': {
          'align-items': '{t_22}'
        },
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'left_end',
          'padding-bottom': '{t_23}',
          hidden: false
        }
      },
      top: {
        'root-container': {
          'flex-direction': '{t_24}',
          'align-items': '{t_25}'
        },
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'top',
          hidden: false
        }
      },
      top_start: {
        'root-container': {
          'flex-direction': '{t_26}',
          'align-items': '{t_27}'
        },
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'top_start',
          'padding-left': '{t_28}',
          hidden: false
        }
      },
      top_end: {
        'root-container': {
          'flex-direction': '{t_29}',
          'align-items': '{t_30}'
        },
        'start-tooltip': {
          hidden: true
        },
        'end-tooltip': {
          position: 'top_end',
          'padding-right': '{t_31}',
          hidden: false
        }
      },
      bottom: {
        'root-container': {
          'flex-direction': '{t_32}',
          'align-items': '{t_33}'
        },
        'start-tooltip': {
          position: 'bottom',
          hidden: false
        },
        'end-tooltip': {
          hidden: true
        }
      },
      bottom_start: {
        'root-container': {
          'flex-direction': '{t_34}',
          'align-items': '{t_35}'
        },
        'start-tooltip': {
          'padding-left': '{t_36}',
          position: 'bottom_start',
          hidden: false
        },
        'end-tooltip': {
          hidden: true
        }
      },
      bottom_end: {
        'root-container': {
          'flex-direction': '{t_37}',
          'align-items': '{t_38}'
        },
        'start-tooltip': {
          position: 'bottom_end',
          'padding-right': '{t_39}',
          hidden: false
        },
        'end-tooltip': {
          hidden: true
        }
      }
    },
    _platform: {
      desktop: {
        'jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        }
      }
    }
  },
  api: {
    config: {
      position: {
        values: [
          'right',
          'right_start',
          'right_end',
          'bottom',
          'bottom_start',
          'bottom_end',
          'left',
          'left_start',
          'left_end',
          'top',
          'top_start',
          'top_end'
        ],
        'doc-description':
          'It can be used to give certain position to the Tooltip.'
      },
      _platform: {
        values: ['mobile', 'desktop']
      }
    },
    data: {
      'root-container': {
        elementRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        'max-width': {
          type: 'size',
          name: 'width'
        },
        spacing: {
          type: 'size',
          name: 'triggerSpacing',
          function: true
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Tooltip.'
        }
      }
    },
    events: {
      'root-container': {
        onAppear: {
          name: 'onAppear',
          platform: 'ios'
        }
      },
      'jds-text': {
        onTextLayout: {
          name: 'onTextLayout',
          platform: 'android'
        }
      }
    },
    a11y: {
      'root-container': {
        properties: {
          role: {
            value: 'tooltip'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
